'use client';

import React, { Dispatch, SetStateAction } from 'react';

import { ThemesNames } from '~types/Theme.types';

export const ThemeContext = React.createContext<{
  theme: ThemesNames;
  setTheme: Dispatch<SetStateAction<ThemesNames>>;
}>({ theme: ThemesNames.White, setTheme: () => {} });
